import React from 'react'
import { Loading } from '@myxplor/ui'
import DefaultForm from '../../../../ui/forms/default-form'

import ManconPersonnelFormFields from './form'
import { changeMANCON } from '../../../../helpers/analytics'

const available = ({ available_actions }) =>
  (available_actions || []).includes('update_nominated_person')

const apiEndPoint = ({ ccs_provider_registration_id }) =>
  `/api/provider-registrations/${ccs_provider_registration_id}/personnel`

const submitEndPoint = (record) =>
  process.env.REACT_APP_API_HOST + apiEndPoint(record)

const formValue = 'change_mancon_personnel'

const changeManconPersonnelForm = (record) => ({ handleSuccess }) => {
  if (!record) {
    return <Loading>Loading B2B Device Registration information</Loading>
  }

  const { ccs_provider_registration_id } = record

  return (
    <DefaultForm
      url={submitEndPoint(record)}
      onBeforeSubmit={changeMANCON}
      value={formValue}
      formComponent={(props) =>
        ManconPersonnelFormFields({ ...props, ccs_provider_registration_id })
      }
      label='Change Management & Control Personnel'
      loadingTitle='Changing Management & Control Personnel...'
      handleSuccess={() =>
        handleSuccess(
          {
            [formValue]: 'Management & Control Personnel has been changed',
          },
          formValue
        )
      }
    />
  )
}

const changeManconPersonnel = ({ record, refresh_b2b_device_list, apiEndPoint }) =>
  available(record)
    ? {
      label: 'Change Management & Control Personnel',
      value: formValue,
      actionForm: changeManconPersonnelForm(record),
      onComplete: () => refresh_b2b_device_list(apiEndPoint),
      onCompletePreserveAction: true,
    }
    : null

export default changeManconPersonnel



// WEBPACK FOOTER //
// ./src/providers-registrations/b2b-device-list/actions/change-action/index.js